import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// NEW: read injected global (safe guard)
const injectedTrack = (typeof window !== "undefined" && window.__NOW_PLAYING__) || null;

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    {/* pass as prop */}
    <App nowPlaying={injectedTrack} />
  </React.StrictMode>
);

reportWebVitals();
